import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";

type DatePickerProps = {
  className?: string;
  fullWidth?: boolean;
  size?: "medium" | "small";
  label: string;
  value?: Date | string;
  onChange: (value: string | Date, keyboardInputValue?: string) => void;
};

export function DatePicker({
  className,
  fullWidth,
  label,
  value,
  size,
  onChange,
}: DatePickerProps) {
  return (
    <MuiDatePicker
      className={className}
      label={label}
      value={value}
      onChange={onChange}
      renderInput={(params) => (
        <TextField fullWidth={fullWidth} size={size} {...params} />
      )}
    />
  );
}
